export const isArray = <T>(value: T) => Array.isArray(value);
